import {ContentType} from "@components/CustomTypography/Content/Content"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import React from "react"

import styles from "./CountsCard.module.scss"

type Props = {
	className?: string
} & ContentType

const CountsCard = (props: Props) => {
	return (
		<div className={`${styles.container} ${props.className}`}>
			<Typography
				as={"p"}
				className={styles.title}
				content={props.data?.title}
				fontWeight={300}
				size={Size.L}
				variant={Variant.Title}
				noPadding
				stripHtml
			/>
			<Typography
				as={"h6"}
				content={props.data?.subtitle}
				fontWeight={600}
				size={Size.L}
				variant={Variant.Description}
				noPadding
			/>
		</div>
	)
}

export default CountsCard
